import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=fd6becae&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd6becae')) {
      api.createRecord('fd6becae', component.options)
    } else {
      api.reload('fd6becae', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=fd6becae&", function () {
      api.rerender('fd6becae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83lxCq9rDfx75/JS/pricehelp.vue"
export default component.exports